<div *ngIf="!adminMode">
    <h3 [id]="'review-stage-title-' + stageSchema.id" class="bold">
        {{ stageSchema.reviewTitle }}
    </h3>
    <hr class="double-hr" />
</div>

<div [ngClass]="{ 'admin-container': adminMode }">
    <div class="title-container title-display" *ngIf="this.adminMode">
        <span class="title">{{ stageSchema.reviewTitle }}</span>
        <lsq-button
            *ngIf="this.hasDocumentFields"
            id="download-all-btn"
            [style.display]="'block'"
            [size]="'sm'"
            appearance="secondary"
            (click)="this.downloadAll()"
            [submitting]="this.loadingDownloadAll"
        >
            Download All
        </lsq-button>
    </div>
    <div>
        <div
            *ngIf="nonDocumentFields.length !== 0"
            class="container-table flex-table"
            [ngClass]="{ 'container-table-admin': adminMode }"
        >
            <div
                class="flex-row"
                [ngClass]="{ 'flex-row-admin': adminMode }"
                *ngFor="let fieldPair of nonDocumentFields"
            >
                <dynamic-container
                    [formGroup]="formGroup"
                    [stageSchema]="{ fieldSchemas: [fieldPair.schema] }"
                    [prospectFields]="fieldPair.value"
                    [reviewMode]="reviewMode"
                    [adminMode]="adminMode"
                    class="dr-container"
                    [viewedBy]="'external'"
                ></dynamic-container>
            </div>
        </div>
        <div class="horizontal-scroll">
            <lsq-data-table
                *ngIf="hasDocumentFields"
                [dataSource]="documentsDataSource"
                [appearance]="appearance"
                [hasFooter]="false"
                [isPaginated]="false"
                [id]="'review-stage-documents-' + stageSchema.id"
            >
                <lsq-column
                    [column]="{
                        key: 'fieldLabel',
                        header: 'Document Name',
                        width: this.adminMode ? '53rem' : '33rem',
                        sortable: false
                    }"
                >
                    <ng-template [custom-cell] let-row="row">
                        <lsq-smart-truncate
                            class="document-name"
                            [value]="row.fieldLabel"
                            [popoverValue]="row.fieldLabel"
                        ></lsq-smart-truncate>
                    </ng-template>
                </lsq-column>

                <lsq-column
                    [column]="{
                        header: 'Document Notes',
                        key: 'documentNotes',
                        sortable: false
                    }"
                >
                    <ng-template [custom-cell] let-row="row">
                        <lsq-smart-truncate
                            class="document-notes"
                            [value]="row?.documentNotes"
                            [popoverValue]="row?.documentNotes"
                        ></lsq-smart-truncate>
                    </ng-template>
                </lsq-column>

                <lsq-column
                    [column]="{
                        header: 'Actions',
                        key: 'id',
                        width: '5rem',
                        sortable: false
                    }"
                >
                    <ng-template [custom-cell] let-row="row">
                        <div class="icon-container">
                            <lsq-icon
                                class="download-document"
                                (click)="downloadDocument(row)"
                                [type]="icons.FaFileDownloadSolid"
                                [color]="color.Green"
                                *ngIf="row.hasDocumentField"
                            >
                            </lsq-icon>
                        </div>
                    </ng-template>
                </lsq-column>
            </lsq-data-table>
            <hr *ngIf="hasDocumentFields" class="hr" />
            <div *ngIf="hasDocumentFields && !adminMode" class="spacer"></div>
        </div>
    </div>
</div>
<div *ngIf="adminMode" class="spacer"></div>
